import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button } from '../../../components/button/button';

interface ReportIncidentProps {
  symptomQuestion: string;
  children?: any;
  activeStep?: number;
  totalStep?: number;
  goBackText?: string;
  onGoBack?: any;
  onGoNext?: any;
  goNextText?: string;
  onCloseReportIncidentPage?: any;
  onNextDisabled?: boolean;
}

export const ReportIncidentDumb = ({
  symptomQuestion,
  children,
  activeStep,
  totalStep,
  goBackText,
  onGoBack,
  onGoNext,
  goNextText,
  onCloseReportIncidentPage,
  onNextDisabled,
}: ReportIncidentProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Grid
        container
        rowGap={1}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <Typography variant="h5">
          {t('incident.INCIDENT_NEW_INCIDENT')}
        </Typography>
        <CancelIcon onClick={onCloseReportIncidentPage} />
        <Grid item display="flex" alignItems="center" columnGap={1} xs={12}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            data-testid="symptomQuestion"
          >
            {symptomQuestion}
          </Typography>
        </Grid>
        <Grid item display="flex" alignItems="center" columnGap={1} xs={12}>
          <Typography variant="subtitle2">
            {t('incident.INCIDENT_STEP_N_OF_N', {
              activeStep,
              totalStep,
            })}
          </Typography>
        </Grid>
        {children}
      </Grid>
      <Grid item display="flex" alignItems="center" columnGap={1} xs={12}>
        {goBackText && (
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            onClick={onGoBack}
            sx={{ my: 2 }}
            label={goBackText}
          />
        )}
        {onGoNext && goNextText && (
          <Button
            testId="moveNext"
            type="submit"
            disabled={onNextDisabled}
            color="secondary"
            variant="contained"
            onClick={onGoNext}
            sx={{ my: 2 }}
            label={goNextText}
          />
        )}
      </Grid>
    </Container>
  );
};
